import type { Translated } from '@uefadigital/panenka';
import { PkIcon } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useWindowSize } from '@hooks/useWindowSize';
import TeamBadge from '@shared/TeamBadge';
import { useTranslateFn } from '@shared/Translate';
import type { Team } from '@shared-types/match.types';

import * as classes from './styles.module.scss';

const Shield = ({ onClick, club }: { onClick: () => unknown; club: Translated<Team> }) => {
  const t = useTranslateFn();
  const { isMobile } = useWindowSize();

  return (
    <div className={classes.shieldContainer}>
      <button type='button' className={classes.shield} onClick={onClick}>
        <TeamBadge size={isMobile ? 100 : 210} team={club} />
        <PkIcon
          className={classes.plusButton}
          size={24}
          color='interaction-compl'
          name={club ? 'actions-edit' : 'actions-add'}
        />
      </button>
      <span className={classes.shieldCaption}>{club ? club.displayName : t('history_h2h_select_club')}</span>
    </div>
  );
};

export default memo(Shield);
